export default __webpack_public_path__ + "static/media/btp-vid-1.c42259ac.mp4";